"use strict"; // https://dom.spec.whatwg.org/#abstractrange

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var AbstractRangeImpl =
/*#__PURE__*/
function () {
  function AbstractRangeImpl(globalObject, args, privateData) {
    _classCallCheck(this, AbstractRangeImpl);

    var start = privateData.start,
        end = privateData.end;
    this._start = start;
    this._end = end;
    this._globalObject = globalObject;
  } // https://dom.spec.whatwg.org/#dom-range-startcontainer


  _createClass(AbstractRangeImpl, [{
    key: "startContainer",
    get: function get() {
      return this._start.node;
    } // https://dom.spec.whatwg.org/#dom-range-startoffset

  }, {
    key: "startOffset",
    get: function get() {
      return this._start.offset;
    } // https://dom.spec.whatwg.org/#dom-range-endcontainer

  }, {
    key: "endContainer",
    get: function get() {
      return this._end.node;
    } // https://dom.spec.whatwg.org/#dom-range-endoffset

  }, {
    key: "endOffset",
    get: function get() {
      return this._end.offset;
    } // https://dom.spec.whatwg.org/#dom-range-collapsed

  }, {
    key: "collapsed",
    get: function get() {
      var _start = this._start,
          _end = this._end;
      return _start.node === _end.node && _start.offset === _end.offset;
    }
  }]);

  return AbstractRangeImpl;
}();

module.exports = {
  implementation: AbstractRangeImpl
};